import { gql } from '@apollo/client';

import { PageInfoFragmentDoc } from '../../../graphql/fragments/PageInfo.generated';
import type * as GraphQLTypes from '../../../graphql/types.generated';
export type TerminalsQueryVariables = GraphQLTypes.Exact<{
  after?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['String']['input']>;
  before?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['String']['input']>;
  first?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['Int']['input']>;
  last?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['Int']['input']>;
  query?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['String']['input']>;
}>;

export type TerminalsQueryResult = { __typename?: 'Query' } & {
  transportTerminals?: GraphQLTypes.Maybe<
    { __typename?: 'TransportTerminalConnection' } & Pick<GraphQLTypes.TransportTerminalConnection, 'totalCount'> & {
        nodes?: GraphQLTypes.Maybe<
          Array<
            { __typename?: 'TransportTerminal' } & Pick<GraphQLTypes.TransportTerminal, 'id' | 'label'> & {
                unlocode: GraphQLTypes.TransportTerminal['code'];
              }
          >
        >;
        pageInfo: { __typename: 'PageInfo' } & Pick<
          GraphQLTypes.PageInfo,
          'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'
        >;
      }
  >;
};

export const TerminalsDocument = gql`
  query terminals($after: String, $before: String, $first: Int, $last: Int, $query: String) {
    transportTerminals(after: $after, before: $before, first: $first, last: $last, query: $query) {
      nodes {
        id
        label
        unlocode: code
      }
      pageInfo {
        ...PageInfo
      }
      totalCount
    }
  }
  ${PageInfoFragmentDoc}
`;
